import { FormattedMessage } from 'react-intl';

import BasePanel from './BasePanel';

const NoDataCard = () => (
    <BasePanel>
        <div className="text-size-14 text-color-darkest margin-bottom-20">
            <FormattedMessage id="intl-msg:engineOil.noDataAvailable" />
        </div>
    </BasePanel>
);

export default NoDataCard;
